import React from 'react';
import { Button, Stack, Typography } from '@mui/material';
import { extractEtiquetteUrlFromContent } from '../utils/colissimoLabel';

type Props = {
  content: string;
  payerName: string;
  outgoing?: boolean;
};

export default function DeliveryPaymentReceivedMessageBody({
  content,
  payerName,
  outgoing = false,
}: Props) {
  const etiquetteUrl = extractEtiquetteUrlFromContent(content);
  const textColor = outgoing ? 'rgba(255,255,255,0.98)' : 'text.primary';

  return (
    <Stack spacing={1.5} sx={{ maxWidth: 300 }}>
      <Typography variant="body2" sx={{ lineHeight: 1.5, color: textColor }}>
        <strong>{payerName}</strong> a payé la livraison, vous pouvez imprimer le bon.
      </Typography>
      <Button
        variant="contained"
        size="small"
        component={etiquetteUrl ? 'a' : 'button'}
        href={etiquetteUrl || undefined}
        target={etiquetteUrl ? '_blank' : undefined}
        rel={etiquetteUrl ? 'noreferrer' : undefined}
        disabled={!etiquetteUrl}
        sx={{
          alignSelf: 'flex-start',
          textTransform: 'none',
          fontWeight: 700,
          borderRadius: 99,
          px: 2,
        }}
      >
        Imprimer le bon
      </Button>
    </Stack>
  );
}
